import { Component, Injectable } from '@angular/core';

// import { Amplify } from 'aws-amplify';
import { environment } from '../../../../../../environments/environment';
import { AppConstants } from './app-constants';
// import { GraphQLResult, generateClient } from 'aws-amplify/api';

// import { graphqlOperation } from '@aws-amplify';

import { CpAssignedCar, CpAssignedCarModel } from '../../model/cpAssignedCar.model';
import {
  ListVehicleMastersModel,
  InputvehicleMaster,
  ListCpVehicleMaintenanceModel,
} from '../../model/vehicle.model';

import {
  createVehicleMasterQueries,
  updateVehicleMasterQueries,
  listcpVehicleMaintenanceQueries,
  getVehicleMasterQueries,
  updatecpVehicleMaintenanceQueries,
  filterByVehicleIDQueries,
  getDaVehicleMaster,
  filterByVehicleStatusQueries,
  getCpAssignedCarQueries,
  filterByCpAssignedCarQueries,
  updateassignedCarQueries,
  surrenderVehicleMasterQueries,
  updateVehicleMasterStatusQueries,
  getReturnAttachmentQueries,
} from '../../graphql/vehicle.queries';
import { RncUsersModel, daVehicalMasterModel } from '../../model/user.model';
import { findUserQueries } from '../../graphql/user.queries';
import { daVehicleMasterModel } from '../../model/drivers.model';
import { daVehicleMaster } from '../../graphql/drivers.queries';

import Amplify, { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "aws-amplify/lib/API/types";
import { HttpClient } from '@angular/common/http';

//const client = generateClient();

// let myAppConfig = environment.myAppConfig;

// Amplify.configure(myAppConfig);

// Amplify.configure({
//   API: {
//     GraphQL: {
//       endpoint:
//         'https://w4tjgxrxvnguldsclbiqylytm4.appsync-api.ap-south-1.amazonaws.com/graphql',
//       region: 'ap-south-1',
//       //aws_appsync_authenticationType: "API_KEY",
//       defaultAuthMode: 'apiKey',
//       apiKey: 'da2-xi2l46vzbrgkpgjgofklofst4m',
//     },
//   },
// });

// endpoint: 'https://abcxyz.appsync-api.us-east-1.amazonaws.com/graphql',
// region: 'us-east-1',
// // Set the default auth mode to "apiKey" and provide the API key value
// defaultAuthMode: 'apiKey',
// apiKey: 'da2-xxxxxxxxxxxxxxxxxxxxxxxxxx'
//status: {eq: "ASSIGN"}
@Injectable({
  providedIn: 'root',
})
//rn_id: { eq: \$rn_id } \$rn_id: String!
export class VehicleService {
  //unAssiged = 'UNASSIGNED';
  created_date: string;
  updated_date: string;
  // map_user_id = '0';
  //queryExplorer: any;

  constructor(
    private http: HttpClient
  ) {
    console.log('config');
    // this.filterByDriversVehicleMaster('RN07967');
    //this.filterByVendor('Relocation');
    this.created_date = this.localDateFormate();
    this.updated_date = this.localDateFormate();

    //const queryExplorer = ;
  }

  private QUERY_KEY = {
    LIST_USER: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpVehicleMaster}`,
    GET_USERS: `${AppConstants.getq}${environment.dbPrefix}${AppConstants.listCpVehicleMaster}`,
    CREATE_USERS: `${AppConstants.create}${environment.dbPrefix}${AppConstants.createCpVehicleMaster}`,
    UPDATE_USERS: `${AppConstants.update}${environment.dbPrefix}${AppConstants.updateCpVehicleMaster}`,

    list_cp_vehicle_maintenance: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpCarMaintenance}`,
    update_cp_vehicle_maintenance: `${AppConstants.list}${environment.dbPrefix}${AppConstants.UpdateCpCarMaintenance}`,

    list_da_vehicleMaster: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listDaVehicleMasters}`,
    update_da_vehicleMaster: `${AppConstants.list}${environment.dbPrefix}${AppConstants.UpdateCpCarMaintenance}`,

    cp_assigned_car_List: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpAssignedCar}`,
    get_cp_assigned_car_: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpAssignedCar}`
  };

  localDateFormate() {
    // Assuming mydate is defined as a Date object
    const mydate = new Date();

    // Convert the date to ISO 8601 format including the local time zone offset
    const isoDateString = mydate.toISOString();

    // Alternatively, you can manually format the date string to include the local time zone offset
    const offset = -mydate.getTimezoneOffset(); // Get the offset in minutes
    const offsetHours = Math.floor(Math.abs(offset) / 60);
    const offsetMinutes = Math.abs(offset) % 60;
    const offsetSign = offset >= 0 ? '+' : '-';

    const formattedDateString = `${mydate.getFullYear()}-${this.padZero(
      mydate.getMonth() + 1
    )}-${this.padZero(mydate.getDate())}T${this.padZero(
      mydate.getHours()
    )}:${this.padZero(mydate.getMinutes())}:${this.padZero(
      mydate.getSeconds()
    )}${offsetSign}${this.padZero(offsetHours)}:${this.padZero(offsetMinutes)}`;
    console.log(formattedDateString); // Output: 2024-02-14T15:02:01+05:30
    return formattedDateString;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }



  /****************************************************************************************
   * VEHICLE
   ***************************************************************************************/

  public async getAllVehicleMaster(nextToken: string | null, limit): Promise<ListVehicleMastersModel> {
    const querylist = this.QUERY_KEY.LIST_USER;
    // console.log('queryExplorer', queryExplorer);
    try {
      const operation = graphqlOperation(getVehicleMasterQueries.query, {
        nextToken: nextToken,
        limit: limit,
      });

      // const response: GraphQLResult<{
      //   querylist: ListVehicleMastersModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response

        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }

  public async filterByVehicleID(
    carID?: string
  ): Promise<ListVehicleMastersModel> {
    const querylist = this.QUERY_KEY.LIST_USER;

    try {
      const operation = graphqlOperation(
        filterByVehicleIDQueries.query,
        {
          id: carID,
        }
      );

      // const response: GraphQLResult<{
      //   querylist: ListVehicleMastersModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response

        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }

  public async filterByVehicleStatus(
    status?: string
  ): Promise<ListVehicleMastersModel> {
    const querylist = this.QUERY_KEY.LIST_USER;

    try {
      const operation = graphqlOperation(filterByVehicleStatusQueries.query, {
        ex_data: status,
      });

      // const response: GraphQLResult<{
      //   querylist: ListVehicleMastersModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response

        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }

  public async createVehicleMaster(
    createdObj: any
  ): Promise<InputvehicleMaster> {
    const querylist = this.QUERY_KEY.CREATE_USERS;
    try {
      const operation = graphqlOperation(createVehicleMasterQueries.mutation, {
        car_model: createdObj.car_model,
        veh_reg_id: createdObj.veh_reg_id,
        policy_no: createdObj.policy_no,
        policy_from: createdObj.policy_from,
        policy_to: createdObj.policy_to,
        agency_name: createdObj.agency_name,
        lease_from: createdObj.lease_from,
        lease_to: createdObj.lease_to,
        car_type: createdObj.car_type,
        ex_data: AppConstants.REQUEST_STATUS.UNASSIGN,
        car_make: createdObj.car_make,
        car_variant: createdObj.car_variant,
        car_color: createdObj.car_color,
        fuel_type: createdObj.fuel_type,
        car_registration_date: createdObj.car_registration_date,
        chasis_number: createdObj.chasis_number,
        map_user_id: AppConstants.REQUEST_STATUS.MAP_USER_ID,
        asset_number: createdObj.asset_number,
        surrender_date: createdObj.surrender_date,
        document_code: createdObj.document_code,
        rental_month: createdObj.rental_month,
        po_number: createdObj.po_number,
        vehicle_rc_book_attachments: createdObj.vehicle_rc_book_attachments,
        insurance_policy_attachments: createdObj.insurance_policy_attachments,
        vehicle_lease_attachments: createdObj.vehicle_lease_attachments,
        created_date: `${this.created_date}`,
        updated_date: `${this.updated_date}`,
      });

      // const response: GraphQLResult<{
      //   querylist: InputvehicleMaster;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }

  // document_code: updateObj.document_code,
  // rental_month: updateObj.rental_month,
  // po_number: updateObj.po_number,

  public async updateVehicleMaster(
    updateObj: any
  ): Promise<InputvehicleMaster> {
    const queryUpdate = this.QUERY_KEY.LIST_USER;
    console.log('Update_value_Servies', updateObj);
    try {
      const operation = graphqlOperation(updateVehicleMasterQueries.mutation, {
        id: updateObj.id,
        car_model: updateObj.car_model,
        veh_reg_id: updateObj.veh_reg_id,
        policy_no: updateObj.policy_no,
        policy_from: updateObj.policy_from,
        policy_to: updateObj.policy_to,
        agency_name: updateObj.agency_name,
        lease_from: updateObj.lease_from,
        lease_to: updateObj.lease_to,
        car_type: updateObj.car_type,
        ex_data: updateObj.ex_data,
        car_make: updateObj.car_make,
        car_variant: updateObj.car_variant,
        car_color: updateObj.car_color,
        fuel_type: updateObj.fuel_type,
        car_registration_date: updateObj.car_registration_date,
        chasis_number: updateObj.chasis_number,
        map_user_id: AppConstants.REQUEST_STATUS.MAP_USER_ID,
        asset_number: updateObj.asset_number,
        surrender_date: updateObj.surrender_date,
        document_code: updateObj.document_code,
        rental_month: updateObj.rental_month,
        po_number: updateObj.po_number,
        vehicle_rc_book_attachments: updateObj.vehicle_rc_book_attachments,
        insurance_policy_attachments: updateObj.insurance_policy_attachments,
        vehicle_lease_attachments: updateObj.vehicle_lease_attachments,
        surrender_car_attachments: updateObj.surrender_car_attachments,
        updated_date: `${this.updated_date}`,
      });

      // const response: GraphQLResult<{
      //   queryUpdate: InputvehicleMaster;
      // }> = (await client.graphql(operation)) as any;


      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[queryUpdate];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }

  public async surrenderVehicle(
    updateObj: any
  ): Promise<InputvehicleMaster> {
    const queryUpdate = this.QUERY_KEY.LIST_USER;
    console.log('Update_value_Servies', updateObj);
    try {
      const operation = graphqlOperation(surrenderVehicleMasterQueries.mutation, {
        id: updateObj.id,
        surrender_date: updateObj.surrender_date,
        surrender_car_attachments: updateObj.surrender_car_attachments,
        updated_date: `${this.updated_date}`,
        ex_data: AppConstants.REQUEST_STATUS.SURRENDER,
      });

      // const response: GraphQLResult<{
      //   queryUpdate: InputvehicleMaster;
      // }> = (await client.graphql(operation)) as any;


      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[queryUpdate];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }

  
  public async updateVehicleStatus(
    updateObj: any
  ): Promise<InputvehicleMaster> {
    const queryUpdate = this.QUERY_KEY.LIST_USER;
    console.log('Update_value_Servies', updateObj);
    try {
      const operation = graphqlOperation(updateVehicleMasterStatusQueries.mutation, {
        id: updateObj.id,
        updated_date: `${this.updated_date}`,
        ex_data: AppConstants.REQUEST_STATUS.UNASSIGN,
      });

      // const response: GraphQLResult<{
      //   queryUpdate: InputvehicleMaster;
      // }> = (await client.graphql(operation)) as any;


      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[queryUpdate];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }

  public async returnAssignedCar(
    createdObj: any
  ): Promise<CpAssignedCarModel> {
    const querylist = this.QUERY_KEY.cp_assigned_car_List;
    try {
      const operation = graphqlOperation(updateassignedCarQueries.mutation, {
        id: createdObj.id,
        vehicle_return_attachments: createdObj.vehicle_return_attachments,
        car_return_date: createdObj.car_return_date,
        status: AppConstants.REQUEST_STATUS.UNASSIGN,
        vehicle_return_submission_date: createdObj.vehicle_return_submission_date
      });

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data in update assigned car.'
        );
      }
    } catch (error) {
      console.error(
        'Error fetching update assigned car request status:',
        error
      );
      throw error;
    }
  }

  // async filterByVehicleMaster(status: string): Promise<vehicleMasterModel> {
  //   try {
  //     // const responses = await client.graphql({
  //     //   query: combine.query,
  //     //   variables: { ex_data: status },
  //     // });

  //     // console.log('Combine_response', responses);

  //     // Prepare the GraphQL query operation
  //     const operation = graphqlOperation(filterByVehicleMasterQueries.query, {
  //       ex_data: status,
  //     });

  //     // Perform the GraphQL query using Amplify API
  //     // listVehicleMasters: vehicleMasterModel;
  //     const response: GraphQLResult<{
  //       listVehicleMasters: vehicleMasterModel;
  //     }> = (await client.graphql(operation)) as any;
  //     console.log(':::RESPOS', response.data);

  //     if (response.data) {
  //       // Extract the result from the response
  //       const returnResponse = response.data.listVehicleMasters;
  //       return returnResponse;
  //     } else {
  //       throw new Error('GraphQL operation returned no data.');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching car request status:', error);
  //     throw error;
  //   }
  // }

  // async fetchCarRequestStatus(carId: string): Promise<CpAssignedCar> {
  //   var status = carId;
  //   try {
  //     // Prepare the GraphQL query operation
  //     const operation = graphqlOperation(cpStatusFilter.query, {
  //       status,
  //     });

  //     // Perform the GraphQL query using Amplify API
  //     const response: GraphQLResult<{ carRequestStatus: CpAssignedCar }> =
  //       (await client.graphql(operation)) as any;
  //     console.log(':::RESPOS', response);

  //     if (response.data) {
  //       // Extract the result from the response
  //       const returnResponse: CpAssignedCar = response.data.carRequestStatus;
  //       return returnResponse;
  //     } else {
  //       throw new Error('GraphQL operation returned no data.');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching car request status:', error);
  //     throw error;
  //   }
  // }

  /****************************************************************************************
   * Drivers
   ***************************************************************************************/

  public async filterByDriversVehicleMaster(
    userID: string
  ): Promise<daVehicleMasterModel> {
    try {
      const operation = graphqlOperation(daVehicleMaster.query, {
        user_id: userID,
      });


      // const response: GraphQLResult<{
      //   listDaVehicleMasters: daVehicleMasterModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse = response.data['listDaVehicleMasters'];
        console.log('Return Response:', returnResponse); // Log the extracted data
        return returnResponse;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }

  /****************************************************************************************
   * CAP ASSITS - CAR
   ***************************************************************************************/

  public async getCpAssignedCar(nextToken: string | null, limit): Promise<CpAssignedCarModel> {
    const querylist = this.QUERY_KEY.cp_assigned_car_List;
    // console.log('queryExplorer', queryExplorer);
    try {
      const operation = graphqlOperation(getCpAssignedCarQueries.query, {
        nextToken: nextToken,
        limit: limit,
      });

      // const response: GraphQLResult<{
      //   querylist: ListVehicleMastersModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response

        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }


  public async filterByAssignedCarBasedonRnID(nextToken: string | null, limit, rnID: any): Promise<CpAssignedCarModel> {
    const querylist = this.QUERY_KEY.cp_assigned_car_List;
    try {
      const operation = graphqlOperation(filterByCpAssignedCarQueries.query, {
        nextToken: nextToken,
        limit: limit,
        rn_id: rnID,
        status: AppConstants.REQUEST_STATUS.ASSIGN,
      });

      // const response: GraphQLResult<{
      //   listCpAssignedCars: CpAssignedCarModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response

        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }

  /****************************************************************************************
   * USER SERVICES
   ***************************************************************************************/

  public async filterByUser(
    id: string,
    userName?: string
  ): Promise<RncUsersModel> {
    console.log('GET_DATA', userName);
    try {
      const operation = graphqlOperation(findUserQueries.query, {
        id: id,
        user_name: userName,
      });

      // const response: GraphQLResult<{
      //   listRncUsers: RncUsersModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse = response.data['listRncUsers'];
        console.log('Return Response:', returnResponse); // Log the extracted data
        return returnResponse;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }

  /****************************************************************************************
   * VECHICLE MAINTENANCE SERVICES
   ***************************************************************************************/

  public async getcpVehicleMaintenanceListService(): Promise<ListCpVehicleMaintenanceModel> {
    const querylist = this.QUERY_KEY.list_cp_vehicle_maintenance;
    console.log('querylist', querylist);
    try {
      const operation = graphqlOperation(
        listcpVehicleMaintenanceQueries.query,
        {}
      );

      // const response: GraphQLResult<{
      //   querylist: ListCpVehicleMaintenanceModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('[cpVehicleMaintenance_list_RESPONSE]', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data cap assist vehicle list.'
        );
      }
    } catch (error) {
      console.error(
        'Error fetching cap assist vehicle list request status:',
        error
      );
      throw error;
    }
  }

  public async updatecpVehicleMaintenanceRequestService(
    updateCpRequest: any
  ): Promise<ListCpVehicleMaintenanceModel> {
    const querylist = this.QUERY_KEY.update_cp_vehicle_maintenance;
    console.log('querylist', querylist);
    try {
      const operation = graphqlOperation(
        updatecpVehicleMaintenanceQueries.mutation,
        {
          id: updateCpRequest.id,
          comments: updateCpRequest.comments,
          request_status: updateCpRequest.request_status,
          updated_date: `${this.updated_date}`,
          ex_data: updateCpRequest.ex_data,
          sla_date: updateCpRequest.sla_date,
        }
      );

      // const response: GraphQLResult<{
      //   querylist: ListCpVehicleMaintenanceModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('[cpVehicleMaintenance_list_RESPONSE]', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data cap assist vehicle maintenance list.'
        );
      }
    } catch (error) {
      console.error(
        'Error fetching cap assist vehicle maintenance list update status:',
        error
      );
      throw error;
    }
  }

  /****************************************************************************************
   * DA VEHICLE MASTER
   ***************************************************************************************/

  public async getDaVehicleMaster(): Promise<daVehicalMasterModel> {
    const querylist = this.QUERY_KEY.list_da_vehicleMaster;
    console.log('querylist', querylist);
    try {
      const operation = graphqlOperation(getDaVehicleMaster.query, {});

      // const response: GraphQLResult<{
      //   querylist: daVehicalMasterModel;
      // }> = (await client.graphql(operation)) as any;


      const response = await API.graphql(operation) as GraphQLResult;

      console.log('[daVehicleMaster_list_RESPONSE]', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data daVehicleMasterlist.'
        );
      }
    } catch (error) {
      console.error('Error fetching daVehicleMasterlist update status:', error);
      throw error;
    }
  }



  
  public async getReturnAttachments(data: any): Promise<CpAssignedCar> {
    const querylist = this.QUERY_KEY.get_cp_assigned_car_;
    console.log('querylist', querylist);
    try {
      const operation = graphqlOperation(getReturnAttachmentQueries.query, {car_id: data.car_id});

      const response = await API.graphql(operation) as GraphQLResult;

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data ReturnAttachment.'
        );
      }
    } catch (error) {
      console.error('Error fetching ReturnAttachment:', error);
      throw error;
    }
  }

  getRandomPassword() {
    var length = 5,
      charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
      retVal = '';
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  sendResetPasswordEmail(data: any) {
    try {
      let resetEmailUrl =
        environment.emailUrl +
        '/' +
        encodeURIComponent(data.firstname).toString() +
        '/' +
        encodeURIComponent(data.credential).toString() +
        '/' +
        encodeURIComponent(data.emailaddress).toString() +
        '/' +
        encodeURIComponent(data.userid);
      return this.http.get(resetEmailUrl, {});
    } catch(error) {

    }
  }
}
